import React, { useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from '../../helper/axios';
import { AuthContext } from '../../context/AuthContext';
import './AddProducts.css';
import DashSidebar from './DashSidebar';


const AddProduct = () => {
    const [products, setProducts] = useState([]);

    const { token } = useContext(AuthContext);

    const location = useLocation();

    const [carat, setCarat] = useState('');
    const [price, setPrice] = useState('');
    const [diamondSku, setDiamondSku] = useState('');
    const [image, setImage] = useState();

    const [getShape, setShape] = useState([]);
    const [getCut, setCut] = useState([]);
    const [getColor, setColor] = useState([]);
    const [getClarity, setClarity] = useState([]);

    // Add separate state variables to track the selected values
    const [selectedShape, setSelectedShape] = useState(getShape.length > 0 ? getShape[0].shape_id : '');
    const [selectedColor, setSelectedColor] = useState(getColor.length > 0 ? getColor[0].color_id : '');
    const [selectedCut, setSelectedCut] = useState(getCut.length > 0 ? getCut[0].cut_id : '');
    const [selectedClarity, setSelectedClarity] = useState(getClarity.length > 0 ? getClarity[0].clarity_id : '');

    // const [skuError, setSkuError] = useState('');


    // Determine the active class based on the current route
    const getActiveClass = (route) => {
        return location.pathname === route ? "active" : "";
    };

    useEffect(() => {
        fetchProducts();
        fetchDiamondData();
    }, []);

    const fetchProducts = async () => {
        try {
            const response = await axios.get('/product_read');
            const sortedProducts = response.data.data.sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            );
            setProducts(sortedProducts);
        } catch (error) {
            console.error(error.response.data);
            // alert('Failed to fetch products.');
        }
    }

    const fetchDiamondData = async () => {
        try {
            const shapeData = await axios.get('/shape_read');
            const shapeProduct = shapeData.data.data;
            setShape(shapeProduct);

            const colorData = await axios.get('/color_read');
            const colorProduct = colorData.data.data;
            setColor(colorProduct);

            const clarityData = await axios.get('/clarity_read');
            const clarityProduct = clarityData.data.data;
            setClarity(clarityProduct);

            const cutData = await axios.get('/cut_read');
            const cutProduct = cutData.data.data;
            setCut(cutProduct);
        } catch (error) {
            console.error(error.response.data);
            // alert('Failed to fetch products.');
        }
    }


    const ListColor = getColor.length > 0 ? getColor.map((color) => (
        <option key={color.color_id} value={color.color_id}>
            {color.color_name}
        </option>
    )) : (
        <option value="">Loading...</option>
    );

    const ListShape = getShape.length > 0 ? (getShape.map((shape) => (
        <option key={shape.shape_id} value={shape.shape_id}>
            {shape.shape_name}
        </option>
    ))) : (
        <option value="">Loading...</option>
    );

    const ListCut = getCut.length > 0 ? (
        getCut.map((cut) => (
            <option key={cut.cut_id} value={cut.cut_id}>
                {cut.cut_name}
            </option>
        ))
    ) : (
        <option value="">Loading...</option>
    );

    const ListClarity = getClarity.length > 0 ? (
        getClarity.map((clarity) => (
            <option key={clarity.clarity_id} value={clarity.clarity_id}>
                {clarity.clarity_name}
            </option>
        ))
    ) : (
        <option value="">Loading...</option>
    );


    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // Check for SKU duplication
        // const isSkuDuplicate = products.some((product) => product.product_sku === diamondSku);

        // if (isSkuDuplicate) {
        //     setSkuError('SKU already exists. Please enter a unique SKU.');
        //     return;
        // }

        try {
            const token = localStorage.getItem('token');

            const formData = new FormData();
            formData.append('shape_id_fk', selectedShape);
            formData.append('color_id_fk', selectedColor);
            formData.append('clarity_id_fk', selectedClarity);
            formData.append('cut_id_fk', selectedCut);
            formData.append('carat', carat);
            formData.append('price', price);
            formData.append('product_sku', diamondSku);
            formData.append('product_image', image);

            formData.append('category_id_fk', '5');
            formData.append('product_name', 'diamond');
            formData.append('stone_type', 'diamond');
            formData.append('matching_band', '0');
            formData.append('in_stock', 1);
            formData.append('metal_id_fk', '11');
            formData.append('product_type_id_fk', '9');
            formData.append('settings_id_fk', '9');
            formData.append('style_id_fk', '14');

            // setSkuError('');

            const response = await axios.post('/product_insert', formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': `multipart/form-data`,
                },
            });

            // console.log(response.data);
            alert('Product Uploaded Sucessfully!!!!!');
        } catch (error) {
            // console.error(error.response.data);
            alert('Add Data First.......');
        }
    };

    return (
        <>
            <div className="modal fade" id="addproductModal" tabIndex="-1" role="dialog" aria-bs-labelledby="addproductModalLabel" aria-bs-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addproductModalLabel"><b>Add Diamond</b></h5>
                            <button type="button" className="close btn" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleFormSubmit} className='py-3 m-0'>

                                <div className="row">
                                    <div className="col-sm-3">
                                        <label htmlFor="" className="form-label">Select Color</label>{}
                                        <select className="form-select" aria-label="Default select example" value={selectedColor} onChange={(e) => setSelectedColor(e.target.value)}>
                                            {ListColor}
                                        </select>
                                    </div>
                                    <div className="col-sm-3">
                                        <label htmlFor="" className="form-label">Select Shape</label>
                                        <select className="form-select" aria-label="Default select example" value={selectedShape} onChange={(e) => setSelectedShape(e.target.value)}>
                                            {ListShape}
                                        </select>
                                    </div>
                                    <div className="col-sm-3">
                                        <label htmlFor="" className="form-label">Select Cut</label>
                                        <select className="form-select" aria-label="Default select example" value={selectedCut} onChange={(e) => setSelectedCut(e.target.value)}>
                                            {ListCut}
                                        </select>
                                    </div>
                                    <div className="col-sm-3">
                                        <label htmlFor="" className="form-label">Select Clarity</label>
                                        <select className="form-select" aria-label="Default select example" value={selectedClarity} onChange={(e) => setSelectedClarity(e.target.value)}>
                                            {ListClarity}
                                        </select>
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    <div className='col-sm-3'>
                                        <label htmlFor="" className="form-label">Carat</label>
                                        <input type="text" className="form-control" name="carat" onChange={(e) => setCarat(e.target.value)} id="" placeholder="Enter Carat" />
                                    </div>

                                    <div className='col-sm-3'>
                                        <label htmlFor="" className="form-label">Price</label>
                                        <input type="text" className="form-control" name="price" onChange={(e) => setPrice(e.target.value)} id="" placeholder="Enter Price" />
                                    </div>

                                    <div className='col-sm-3'>
                                        <label htmlFor="" className="form-label">Diamond SKU</label>
                                        <input type="text" required className="form-control" name="Diamond SKU" onChange={(e) => setDiamondSku(e.target.value)} id="" placeholder="Enter Diamond SKU" />
                                        {/* {skuError && <div className="mt-2 alert alert-danger">{skuError}</div>} */}
                                    </div>

                                    <div className="col-sm-12 my-4">
                                        <label htmlFor="" className="form-label">Diamond Images</label>
                                        <input className="form-control m-0" name="product_image" accept='image/*' type="file" onChange={(e) => setImage(e.target.files[0])} />

                                        {/* <label className='form-label mt-5'>Uploaded Images</label>
                                            <ul className='image-list p-0 ml-4'>
                                                <li className='light-border'>Image thumbnail</li>
                                                <li className='light-border'>Image thumbnail</li>
                                                <li className='light-border'>Image thumbnail</li>
                                                <li className='light-border'>Image thumbnail</li>
                                            </ul> */}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <div className='text-right'>
                                            <button type="submit" className="btn btn__primary mt-3">Add Diamond</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AddProduct;